export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 3.25a.75.75 0 01.75.75v16a.75.75 0 01-1.5 0v-.449l-3.585-1.12a5.752 5.752 0 01-9.202-2.876L4.75 15.02a.75.75 0 01-1.5-.02V9a.75.75 0 011.5-.02l14.5-4.531V4a.75.75 0 01.75-.75zm-.75 2.77l-14.5 4.531v2.898l14.5 4.53V6.02zM8.326 16.137a4.25 4.25 0 005.478 1.712l-5.478-1.712z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};